import loadable from '@loadable/component';

export const CmsEmailCampaignSignupSingleBlockLoadable = loadable(
  () => import('./CmsEmailCampaignSignupSingleBlock'),
  { resolveComponent: (module) => module.CmsEmailCampaignSignupSingleBlock },
);
